import { ModelBase, Property } from '@skylab-shared/core';

export class ProductOssVatRateModel extends ModelBase {

    @Property()
    public countryId: number;

    @Property()
    public vatRateId: number;

}
